import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ColeccionPage = lazy(() => import('../pages/coleccion/page'));
const ProductoPage = lazy(() => import('../pages/producto/page'));
const NosotrosPage = lazy(() => import('../pages/nosotros/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/coleccion',
    element: <ColeccionPage />,
  },
  {
    path: '/producto/:id',
    element: <ProductoPage />,
  },
  {
    path: '/nosotros',
    element: <NosotrosPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
